module.exports = __webpack_public_path__ + "static/media/gabriel_bit.967c969b.jpeg";